import { combineReducers, Reducer, AnyAction } from '@reduxjs/toolkit';

import reducerGetVacancyList from './reducers/reducerVacancy';
import reducerCreateVacancy from './reducers/reducerCreateVacancy';
import reducerSingleVacancy from './reducers/reducerSingleVacancy';
import reducerApplicationForm from './reducers/reducerApplicationForm';
import reducerSingleApplication from './reducers/reducerSingleApplication';
import reducerApplicationCreateIV from './reducers/reducerApplicationCreate';

interface RecruitingReducers {
	vacancyList: Reducer<any, AnyAction>;
	createVacancy: Reducer<any, AnyAction>;
	singleVacancy: Reducer<any, AnyAction>;
	applicationsList: Reducer<any, AnyAction>;
	singleApplication: Reducer<any, AnyAction>;
	applicationCreate: Reducer<any, AnyAction>;
}

const RecruitingStore = combineReducers<RecruitingReducers>({
	vacancyList: reducerGetVacancyList,
	createVacancy: reducerCreateVacancy,
	singleVacancy: reducerSingleVacancy,
	applicationsList: reducerApplicationForm,
	singleApplication: reducerSingleApplication,
	applicationCreate: reducerApplicationCreateIV,
});

export default RecruitingStore;
